import BancontactMobileAuthActionModal from './modals/BancontactMobileAuthActionModal';

const RetryPaymentOverlays: React.FC = () => {
  return (
    <>
      <BancontactMobileAuthActionModal />
    </>
  );
};

export default RetryPaymentOverlays;
